import { useDebouncedValue } from '@mantine/hooks';
import { useCallback, useMemo, useState } from 'react';

import {
  FilterOption,
  filterOptionsBySearch,
} from '../utils/filter-options';

const DEFAULT_DEBOUNCE_MS = 200;

export function useSearchableOptions<T extends FilterOption>(
  options: T[],
  debounceMs = DEFAULT_DEBOUNCE_MS,
) {
  const [search, setSearch] = useState('');
  const [debouncedSearch] = useDebouncedValue(search, debounceMs);

  const filteredOptions = useMemo(
    () => filterOptionsBySearch(options, debouncedSearch),
    [debouncedSearch, options],
  );

  const resetSearch = useCallback(() => {
    setSearch('');
  }, []);

  const isSearchPending = search !== debouncedSearch;

  return {
    debouncedSearch,
    filteredOptions,
    isSearchPending,
    resetSearch,
    search,
    setSearch,
  };
}
